import { Box, Typography, Skeleton, Alert } from '@mui/material'
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism'
import { useGetList } from 'react-admin'
import { useEffect } from 'react'

export default function CharityTotal() {
  const { data, isLoading, error, isFetching } = useGetList('site_settings', {
    filter: { identifier: 'charitable_contributions_total' },
    pagination: { page: 1, perPage: 1 },
  })

  useEffect(() => {
    if (!error) return
    const hasRetried =
      typeof window !== 'undefined' &&
      sessionStorage.getItem('charityTotalRetry') === '1'
    if (!hasRetried) {
      try {
        sessionStorage.setItem('charityTotalRetry', '1')
      } catch (e) {}
      window.location.reload()
    }
  }, [error])

  useEffect(() => {
    if (!isLoading && !isFetching && data) {
      try {
        if (sessionStorage.getItem('charityTotalRetry')) {
          sessionStorage.removeItem('charityTotalRetry')
        }
      } catch (e) {}
    }
  }, [data, isLoading, isFetching])

  if (error) {
    const hasRetried =
      typeof window !== 'undefined' &&
      sessionStorage.getItem('charityTotalRetry') === '1'
    if (!hasRetried) {
      return null
    }
    try {
      sessionStorage.removeItem('charityTotalRetry')
    } catch (e) {}
    return <Alert severity="error">Failed to fetch charity total</Alert>
  }

  const charityTotal = data?.[0]?.value || '0'
  const loading = isLoading || isFetching

  return (
    <Box flex={1}>
      <Box
        sx={{
          backgroundColor: '#e91e63',
          padding: '16px',
          color: '#fff',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <VolunteerActivismIcon sx={{ fontSize: 20 }} />
            <Typography
              variant="h3"
              sx={{ fontSize: 'initial', fontWeight: 'bold', mt: 0 }}
            >
              Charitable Contributions Total
            </Typography>
          </Box>
          <Typography
            variant="h4"
            sx={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              mt: 0,
            }}
          >
            {loading ? (
              <Skeleton
                variant="text"
                width={100}
                sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}
              />
            ) : (
              <>
                £
                {parseFloat(charityTotal).toLocaleString('en-GB', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </>
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
